import React from "react";
import About from "../components/About";

const AboutPage: React.FC = () => <About />;

export default AboutPage;
